import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import * as firebase from "firebase";

@Injectable()
export class AdminGuard implements CanActivate {
	constructor(private router: Router) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		const current = firebase.auth().currentUser;
		if (!current) {
			this.router.navigateByUrl("/error/403");
			return of(false);
		}
		return of(true);
	}
}
